import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResolveFn } from '@angular/router';

import { Message, MessagesService } from '../shared/services/messages.service';
import { UserService } from '../shared/services/user.service';

export const messagesResolver: ResolveFn<void> = () => {
  inject(UserService).set('unreadMessages', 0);
}

@Component({
  selector: 'app-messages',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './messages.component.html',
  styleUrl: './messages.component.scss'
})
export class MessagesComponent {
  private messagesService = inject(MessagesService);
  public messages: Message[] = [];
  loading = true;

  constructor() {
    this.messagesService.getMessages(true).subscribe(messages => {
      this.messages = messages;
      this.loading = false;
    });
  }
}
